<div class="relative">
    <app-header class="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100"></app-header>
    <main class="min-h-screen">
        <router-outlet />
    </main>
    <app-footer />
</div>